import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import { DocumentDirection } from '~/types/document';
import lazyImport from '~/utils/lazyImport';

const AnalyticsPurchasesPricesDashboardPage = lazyImport(
  () => import('~/views/analytics-purchases-prices-dashboard/AnalyticsPurchasesPricesDashboardPage'),
);
const ItemVolumesDashboardPage = lazyImport(() => import('~/views/item-volumes-dashboard/ItemVolumesDashboardPage'));
const AveragePricesDashboardPage = lazyImport(
  () => import('~/views/average-prices-dashboard/AveragePricesDashboardPage'),
);
const ItemQuantitiesDashboardPage = lazyImport(
  () => import('~/views/item-quantities-dashboard/ItemQuantitiesDashboardPage'),
);

export const analyticsPurchasesPricesDashboardPages: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={RouteConfig.AnalyticsPurchasesProductsPriceChanges.buildLink()} replace />,
  },
  {
    path: 'products-price-changes',
    element: <AnalyticsPurchasesPricesDashboardPage />,
  },
  {
    path: 'item-volumes',
    element: <ItemVolumesDashboardPage direction={DocumentDirection.received} section="item_volumes" />,
  },
  {
    path: 'average-prices',
    element: <AveragePricesDashboardPage direction={DocumentDirection.received} section="average_prices" />,
  },
  {
    path: 'item-quantities',
    element: <ItemQuantitiesDashboardPage direction={DocumentDirection.received} section="item_quantities" />,
  },
];
